import PaginationObserver from './PaginationObserver';

export default PaginationObserver;
